import type { FC } from 'react'
import React from 'react'
import { TextInput } from '@/components/ui/fields'
import { useEffectAfterMount } from '@/utils/hooks'
import { fieldModifiers } from '../../constants'
import type { IFeedbackFormField, IFeedbackFormValues } from '../../interfaces'
import { EFieldName } from '../../interfaces'
import type { IFeedbackFieldProps } from './interfaces'

const FeedbackField: FC<IFeedbackFormField & IFeedbackFieldProps> = props => {
  const {
    fieldName,
    type = 'text',
    isFieldRequired = () => true,
    saveMessage,
    errors,
    values,
    form,
    initialValues,
    isAuthenticated,
  } = props

  const isRequired = isFieldRequired(errors, values)
  const isMessageField = fieldName === EFieldName.message

  useEffectAfterMount(() => {
    if (!isRequired && !isAuthenticated) form.resetFieldState(fieldName as keyof IFeedbackFormValues)
    //eslint-disable-next-line
  }, [isRequired])

  const isPhoneField = fieldName === EFieldName.phone

  return (
    <TextInput
      name={fieldName}
      type={type}
      placeholderId={isPhoneField ? undefined : `feedbackPage.feedbackForm.label.${fieldName}`}
      modifiers={fieldModifiers}
      onChange={isMessageField ? saveMessage : undefined}
      className="space-holder8 feedback-page-form__input"
      isRequired={isRequired}
      isDisabled={!isMessageField && Boolean(initialValues[fieldName as keyof IFeedbackFormValues])}
      maxLength={isPhoneField ? 1000 : undefined}
    />
  )
}

export default FeedbackField
